import React from 'react'
import {Route, Navigate, Routes} from 'react-router-dom';
import {UserContext} from '../UserContext';
import Header from "../components/Header";
import Home from '../pages/Home';
import {Backdrop, CircularProgress} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {Division, DivContent} from "../components/Header/styled";
import UserBarInfos from "../components/UserBarInfos";
import NotAfound from '../pages/NotAfound';
import Duplicate from '../pages/Duplicate';
import Search from '../pages/Repository/Search';
import Show from '../pages/Repository/Show';
import List from '../pages/Repository/List';
import SendImages from '../pages/SendImages';
import UserPending from '../pages/UserPending';
import UserApproved from '../pages/UserApproved';
import EditUser from '../pages/EditUser';
import MyRequests from '../pages/MyRequests';
import FreightControl from '../pages/FreightControl';
import ChangePassword from '../pages/ChangePassword';
import {useLocation} from 'react-router-dom';
import PriceSimulator from '../pages/PriceSimulator';
import DashboardBI from '../pages/DashboardBI';

const LoginRoutes = () => {
    
    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: 9999,
            color: '#fff',
        },
    }));

    const classes = useStyles();
    const location = useLocation();

    const {login, loading, data} = React.useContext(UserContext);

    if (login === false) return <Navigate to={`${process.env.PUBLIC_URL}/login`}/>;
    else if (login === null || !data.PKGrupo) return null;

    return (
        <Division inicio={location.pathname === '/area-restrita/usuario/inicio'}>
            {loading &&
                <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
            }
            <Header/>
            <DivContent>
                <UserBarInfos/>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/inicio" element={<Home/>}/>
                    {['100', '101', '102', '103', '104', '105', '107', '108'].includes(data.PKGrupo) && 
                        <>
                            <Route path="/repositorio" element={<Search/>}/>
                            <Route path="/repositorio/:pk" element={<Show/>}/>
                            <Route path="/repositorios/:pks" element={<List/>}/>
                        </>
                    }                    
                    {['100', '101', '104', '105', '107', '108'].includes(data.PKGrupo) && <Route path="/duplicatas" element={<Duplicate/>}/>}
                    {['100', '103'].includes(data.PKGrupo) && <Route path="/enviar-imagens" element={<SendImages/>}/>}
                    {['100', '108'].includes(data.PKGrupo) && <Route path="/usuarios-pendentes" element={<UserPending/>}/>}
                    {['100', '101', '105', '108'].includes(data.PKGrupo) && <Route path="/usuarios-aprovados" element={<UserApproved/>}/>}
                    {['100', '101', '102', '104', '105', '107', '108'].includes(data.PKGrupo) && <Route path="/meus-pedidos" element={<MyRequests/>}/>}
                    {['100','101', '105', '109'].includes(data.PKGrupo) && <Route path="/controle-de-frete/*" element={<FreightControl/>}/>}
                    {['100', '101', '104'].includes(data.PKGrupo) && <Route path="/simulador-de-preco" element={<PriceSimulator />} />}
                    {['100', '101', '103', '104', '105', '108', '109', '110', '111'].includes(data.PKGrupo) && <Route path="/dashboard-bi" element={<DashboardBI />} />}
                    <Route path="/editar/perfil" element={<EditUser/>}/>
                    <Route path="/alterar-senha" element={<ChangePassword />}/>
                    <Route path="*" element={<NotAfound/>}/>
                </Routes>                
            </DivContent>           
        </Division>
    )
}

export default LoginRoutes;